/* R3: enrich the existing Shopify Google gtag collection event; only home needs a new sender.
   Load before content_for_header so Google's dataLayer wrapper receives the enriched command. */
(function () {
  'use strict';
  if (window.PlentumListTracking) return;
  window.PlentumListTracking = true;
  var layer = window.dataLayer = window.dataLayer || [];
  var push = layer.push;
  function enrich(command) {
    if (!command || command[0] !== 'event' || command[1] !== 'view_item_list') return;
    var data = command[2];
    if (!data || !Array.isArray(data.items)) return;
    data.items.forEach(function (item, index) {
      // Shopify Google supplies legacy id/name plus SKU and variant_id on detail/cart/list events.
      // Preserve its actual funnel ID (including the Google target-country prefix).
      item.item_id = String(item.item_id || item.id || item.sku || item.variant_id || '');
      item.item_name = item.item_name || item.name;
      if (item.index == null) item.index = index;
    });
  }
  layer.forEach(enrich);
  layer.push = function () {
    for (var i = 0; i < arguments.length; i++) {
      try { enrich(arguments[i]); } catch (e) { /* analytics must never interrupt shopping */ }
    }
    return push.apply(this, arguments);
  };

  var sent = Object.create(null), retry;
  function homeLists() {
    var waiting = false;
    document.querySelectorAll('script[data-plentum-home-list]').forEach(function (node) {
      try {
        var data = JSON.parse(node.textContent), key = JSON.stringify(data);
        if (sent[key] || !data.items.length) return;
        if (typeof window.gtag !== 'function') { waiting = true; return; }
        window.gtag('event', 'view_item_list', data);
        sent[key] = true;
      } catch (e) { /* malformed section data must not interrupt the page */ }
    });
    clearTimeout(retry);
    if (waiting) retry = setTimeout(homeLists, 500);
  }
  document.addEventListener('DOMContentLoaded', homeLists);
  document.addEventListener('shopify:section:load', homeLists);
  if (document.readyState !== 'loading') homeLists();
})();
